import React, { useEffect } from 'react';

import { Grid, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { useInView } from 'react-intersection-observer';

import tennesseeMap from '../../assets/tenesseeMap.png';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    paddingBottom: '5.56rem',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    [theme.breakpoints.down('md')]: {
      backgroundColor: theme.palette.common.background,
      paddingBottom: '4rem'
    }
  },
  epInfoCont: {
    width: '81%',
    marginTop: '4.25rem'
  },
  epHeaderAndMap: {
    width: '50%',
    paddingLeft: '7rem',
    [theme.breakpoints.down('md')]: {
      paddingLeft: '3.5rem'
    },
    [theme.breakpoints.down('sm')]: {
      width: '71.5%'
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '0px',
      width: '100%'
    }
  },
  mapImgCont: {
    width: '327px',
    marginTop: '0rem',
    marginLeft: '0rem',
    [theme.breakpoints.down('xs')]: {
      width: '98%',
      marginLeft: '0px'
    }
  },
  stateTitle: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center'
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.5rem'
    }
  },
  headerDescriptionCont: {
    width: '50%',
    marginTop: '4rem',
    [theme.breakpoints.down('md')]: {
      marginTop: '2rem',
      width: '71.5%'
    },
    [theme.breakpoints.down('xs')]: {
      width: '98%',
      marginTop: '2.4rem'
    }
  },

  numStatCont: {
    marginTop: '1rem',
    marginBottom: '1.5rem',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  nums: {
    // width: '30%',
    maxWidth: '236px',
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      width: '150px'
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      textAlign: 'left'
    }
  },
  numsPG: {
    width: '60%',
    marginLeft: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 'auto',
      marginTop: '1.4rem',
      width: '61.25%'
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0px',
      marginTop: '1.4rem',
      width: '100%'
    }
  },
  sourceCont: {
    marginTop: '4.8rem',
    [theme.breakpoints.down('xs')]: {
      marginTop: '2rem'
    }
  },
  introParagraph: {
    color: '#fff',
    fontFamily: 'neuePlakR',
    fontSize: '24px',
    width: '890px',
    textAlign: 'center',
    marginTop: '88px',
    lineHeight: '48px',
    letterSpacing: '1.5px',
    [theme.breakpoints.down('md')]: {
      fontSize: '18px',
      marginTop: '50px',
      width: '700px',
      lineHeight: '2rem',
      letterSpacing: '.125rem'
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '18px',
      marginTop: '50px',
      width: '500px',
      lineHeight: '2rem',
      letterSpacing: '.125rem'
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '16px',
      width: '81%',
      lineHeight: '33px',
      letterSpacing: '1.5px'
    }
  },
  border2: {
    borderTop: '1px solid #7B7B7B ',
    width: '15%',
    marginTop: '88px',
    [theme.breakpoints.down('sm')]: {
      width: '81%',
      marginTop: '70px'
    }
  },
  // ================================================
  subhead5: {
    ...theme.typography.subhead5,
    color: '#BFDA1C',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center'
    }
  },
  stat1: {
    ...theme.typography.stat1,
    [theme.breakpoints.down('md')]: {
      fontSize: '3.7rem'
    },
    [theme.breakpoints.down('sm')]: {
      ...theme.typography.mobile.stat1
    }
  },
  stat2: {
    ...theme.typography.stat2,
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      ...theme.typography.mobile.stat2
    }
  },
  source: {
    ...theme.typography.caption
  }
}));

const Episode5 = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesXS = useMediaQuery(theme.breakpoints.down('xs'));
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesMD = useMediaQuery(theme.breakpoints.down('md'));
  const { ref, inView } = useInView({ threshhold: 0 });

  useEffect(() => {
    if (inView) {
      props.setActive(5);
    }
  });

  return (
    <>
      <Grid id="tennessee" ref={ref} justifyContent="center" container className={classes.wrapper}>
        <div style={{ borderTop: '1px solid #7B7B7B ', width: '81%', marginTop: '88px' }} />
        <Grid container className={classes.introParagraph}>
          <Grid item>
            <p>
              In the US, nearly a quarter of transgender women are living with HIV.{' '}
              <span style={{ fontFamily: 'neuePlakB', color: '#BFDA1C' }}>
                Discrimination, poverty, and housing insecurity
              </span>{' '}
              are just a few of the linked factors that may put them disproportionately at risk for
              the virus.
            </p>
          </Grid>
        </Grid>
        <div
          // style={{ borderTop: '1px solid #7B7B7B ', width: '15%', marginTop: '88px' }}
          className={classes.border2}
        />
        <Grid
          container
          direction={matchesSM ? 'column' : undefined}
          alignItems={matchesSM ? 'center' : undefined}
          justifyContent="center"
          className={classes.epInfoCont}
        >
          <Grid
            container
            direction="column"
            alignItems={matchesMD ? 'center' : undefined}
            className={classes.epHeaderAndMap}
          >
            <Grid item>
              <Typography className={classes.subhead5}>EPISODE 5</Typography>
            </Grid>
            <Grid item>
              <Typography variant="h1" className={classes.stateTitle}>
                Memphis, Tennessee
              </Typography>
            </Grid>
            <Grid item className={classes.mapImgCont}>
              <img src={tennesseeMap} alt="map indicating Alabama" style={{ width: '100%' }} />
            </Grid>
          </Grid>
          <Grid container direction="column" className={classes.headerDescriptionCont}>
            <Grid container className={classes.numStatCont}>
              <Grid item className={classes.nums}>
                <Typography className={classes.stat1}>33%</Typography>
              </Grid>
              <Grid item className={classes.numsPG}>
                <Typography className={classes.stat2}>
                  <span style={{ fontFamily: 'neuePlakB' }}>of trans people </span> surveyed in the
                  US in 2015 reported at least one negative EXPERIENCE while seeking medical care
                  related to being transgender.
                </Typography>
              </Grid>
            </Grid>

            <Grid container className={classes.numStatCont}>
              {/* <Grid item className={classes.nums}>
                <Typography style={{ marginTop: '-1rem' }} className={classes.stat1}>
                  1 in 5{' '}
                </Typography>
              </Grid> */}
              <Grid item className={classes.numsPG} style={{ width: '100%', marginLeft: 0 }}>
                <Typography className={classes.stat2}>
                  In 2015, nearly <span style={{ fontFamily: 'neuePlakB' }}> 1 in 4 </span>trans
                  people surveyed reported facing discrimination while seeking housing.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Episode5;
